import {
  type CheckboxChangeEventType,
  DynamicFormRequiredType,
  type DynamicFormSettings,
} from '@myosh/odin-components';
import i18next from '../../../i18n';
import { dataSettings } from './common.util';

export const groupDisplayTypes = [
  { text: 'Expand', value: 'EXPAND' },
  { text: 'Collapse', value: 'COLLAPSE' },
];

export const GroupDetailsFormSettings: DynamicFormSettings = {
  id: 'GroupDetailsSettingsGroup',
  caption: '',
  fields: [
    {
      id: 'caption',
      fieldType: 'TEXTFIELD',
      fieldName: 'caption',
      caption: i18next.t('name', 'Name'),
      required: DynamicFormRequiredType.True,
      position: 5,
      permissions: { edit: true, read: true },
    },
    {
      id: 'displayType',
      fieldType: 'OPTIONGROUP',
      fieldName: 'displayType',
      caption: i18next.t('display-type', 'Display Type'),
      required: DynamicFormRequiredType.False,
      dynamicProperties: {
        data: groupDisplayTypes,
      },
      dataSettings,
      position: 10,
    },
  ],
  fieldValueConverters: {
    CHECKBOX: (value) => {
      const convertedValue = value as unknown as CheckboxChangeEventType;
      return convertedValue.checked;
    },
  },
};
